export default __webpack_public_path__ + "images/0x04068da6c83afcfa0e13ba15a6696662335d5b75.png";